<script lang="ts">
  import type { LayoutProps } from './$types';
  import { page } from '$app/state';
  import ClassInfoLayout from '$lib/components/classes/ClassInfoLayout.svelte';

  let { params, data, children }: LayoutProps = $props();

  let activePage: 'students' | 'classInfo' = $derived.by(() => {
    if (page.route.id === '/(loginwrapper)/admin/classes/[id]/students') {
      return 'students';
    }

    return 'classInfo';
  });
</script>

<ClassInfoLayout {activePage} classId={params.id} classPromise={data.classPromise} hrefPrefix="/admin">
  {@render children?.()}
</ClassInfoLayout>
